module.exports = __webpack_public_path__ + "img/gps-slash.073f2e50.svg";